export default "__VITE_ASSET__DCUv7QHN__"